import { create } from 'zustand';

export interface Toast {
  id: number;
  message: string;
  tone: 'info' | 'warn';
}

interface UiState {
  /** True while a sheet/dialog is open; keyboard shortcuts pause. */
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  toast: Toast | null;
  showToast: (message: string, tone?: Toast['tone']) => void;
  hideToast: () => void;
}

let toastId = 0;
let toastTimer: ReturnType<typeof setTimeout> | undefined;

export const useUiStore = create<UiState>((set) => ({
  modalOpen: false,
  setModalOpen: (modalOpen) => set({ modalOpen }),
  toast: null,
  showToast: (message, tone = 'info') => {
    toastId += 1;
    set({ toast: { id: toastId, message, tone } });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => set({ toast: null }), 2400);
  },
  hideToast: () => set({ toast: null }),
}));

/** Non-React access (command bus, platform adapters). */
export const showToast = (message: string, tone?: Toast['tone']) =>
  useUiStore.getState().showToast(message, tone);
